import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import AccountBalance from '@material-ui/icons/AccountBalance';

import { libraryGeneralService } from '../services/libraryService'
import { SET_GENERAL_LIBRARIES } from '../actions/actionTypes'
import Spinner from '../components/Spinner'

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    }
}));

function Libraries(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false)

    const librariesState = useSelector(state => state.library);

    const fetchGeneralLIbraries = () => {
        setIsLoading(true)
        libraryGeneralService()
        .then(({data}) => {
            dispatch({ type: SET_GENERAL_LIBRARIES, payload: data })
            setIsLoading(false)
        })
    }

    const libraryDetails = library => {
        props.history.push({
            pathname: '/library-detail', 
            state: {library: library}
        })
    }

    useEffect(() => {
        if(!librariesState.generalList.length)
            fetchGeneralLIbraries()
    }, [])

    return (
        <Grid className={classes.root}>
            {isLoading && <Spinner />}
            <List>
                {librariesState.generalList.map((library, index) => (
                    <ListItem divider={true} key={index} onClick={() => libraryDetails(library)}>
                        <ListItemIcon>
                            <AccountBalance />
                        </ListItemIcon>
                        <ListItemText primary={library.name} secondary={library.initials} />
                    </ListItem>
                ))}
            </List>

            {!isLoading && 
                <Box display="flex" p={1} justifyContent="center">
                    <Button 
                        color="primary" 
                        fullWidth={true}
                        onClick={() => props.history.goBack()}>
                            Voltar
                    </Button>
                </Box>
            }
        </Grid>
    );
}
  
export default Libraries;